
define('text!core/controllers/CmsPage.html',[],function () { return '<article class="page clearfix" data-ng-controller="CmsPageController">\n    <div data-ng-if="cms.spotName" data-cms-spot data-spot-name="{{cms.spotName}}"></div>\n</article>';});

